"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORLD_EXTENT = exports.RADIUS = exports.PROJECTIONS = exports.MAX_SAFE_Y = exports.HALF_SIZE = exports.EXTENT = void 0;
exports.fromEPSG4326 = fromEPSG4326;
exports.toEPSG4326 = toEPSG4326;

var _Projection = _interopRequireDefault(require("./Projection.js"));

var _Units = _interopRequireDefault(require("./Units.js"));

var _math = require("../math.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/proj/epsg3857
 */


/**
 * Radius of WGS84 sphere
 *
 * @const
 * @type {number}
 */
var RADIUS = 6378137;
/**
 * @const
 * @type {number}
 */

exports.RADIUS = RADIUS;
var HALF_SIZE = Math.PI * RADIUS;
/**
 * @const
 * @type {import("../extent.js").Extent}
 */

exports.HALF_SIZE = HALF_SIZE;
var EXTENT = [-HALF_SIZE, -HALF_SIZE, HALF_SIZE, HALF_SIZE];
/**
 * @const
 * @type {import("../extent.js").Extent}
 */

exports.EXTENT = EXTENT;
var WORLD_EXTENT = [-180, -85, 180, 85];
/**
 * Maximum safe value in y direction
 * @const
 * @type {number}
 */

exports.WORLD_EXTENT = WORLD_EXTENT;
var MAX_SAFE_Y = RADIUS * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */

exports.MAX_SAFE_Y = MAX_SAFE_Y;

var EPSG3857Projection =
/** @class */
function (_super) {
  __extends(EPSG3857Projection, _super);
  /**
   * @param {string} code Code.
   */


  function EPSG3857Projection(code) {
    return _super.call(this, {
      code: code,
      units: _Units["default"].METERS,
      extent: EXTENT,
      global: true,
      worldExtent: WORLD_EXTENT,
      getPointResolution: function getPointResolution(resolution, point) {
        return resolution / (0, _math.cosh)(point[1] / RADIUS);
      }
    }) || this;
  }

  return EPSG3857Projection;
}(_Projection["default"]);
/**
 * Projections equal to EPSG:3857.
 *
 * @const
 * @type {Array<import("./Projection.js").default>}
 */


var PROJECTIONS = [new EPSG3857Projection('EPSG:3857'), new EPSG3857Projection('EPSG:102100'), new EPSG3857Projection('EPSG:102113'), new EPSG3857Projection('EPSG:900913'), new EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'), new EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')];
/**
 * Transformation from EPSG:4326 to EPSG:3857.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension (default is `2`).
 * @return {Array<number>} Output array of coordinate values.
 */

exports.PROJECTIONS = PROJECTIONS;

function fromEPSG4326(input, opt_output, opt_dimension) {
  var length = input.length;
  var dimension = opt_dimension > 1 ? opt_dimension : 2;
  var output = opt_output;

  if (output === undefined) {
    if (dimension > 2) {
      // preserve values beyond second dimension
      output = input.slice();
    } else {
      output = new Array(length);
    }
  }

  for (var i = 0; i < length; i += dimension) {
    output[i] = HALF_SIZE * input[i] / 180;
    var y = RADIUS * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));

    if (y > MAX_SAFE_Y) {
      y = MAX_SAFE_Y;
    } else if (y < -MAX_SAFE_Y) {
      y = -MAX_SAFE_Y;
    }

    output[i + 1] = y;
  }

  return output;
}
/**
 * Transformation from EPSG:3857 to EPSG:4326.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension (default is `2`).
 * @return {Array<number>} Output array of coordinate values.
 */


function toEPSG4326(input, opt_output, opt_dimension) {
  var length = input.length;
  var dimension = opt_dimension > 1 ? opt_dimension : 2;
  var output = opt_output;

  if (output === undefined) {
    if (dimension > 2) {
      // preserve values beyond second dimension
      output = input.slice();
    } else {
      output = new Array(length);
    }
  }

  for (var i = 0; i < length; i += dimension) {
    output[i] = 180 * input[i] / HALF_SIZE;
    output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / RADIUS)) / Math.PI - 90;
  }

  return output;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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